var styles = {"fileInput":"styles_file-input__er17B","input":"styles_input__TRUTX","inputWrapper":"styles_input-wrapper__G1JJY","errored":"styles_errored__MCMXS","dark":"styles_dark__hT0fl","dropOverlay":"styles_drop-overlay__YR1uS","draggedOver":"styles_dragged-over__ccEoR"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
